import { Fragment, useEffect, useRef } from "react";
import ReactPlayer from "react-player";



const VedioPlayer = (props) => {

  let { url, watchTime, updateWatchTimes, thumbnail, isLocked} = props;
console.log("isLocked",isLocked)

  return (
    <Fragment>
      <ReactPlayer
        url={url}
        light={
          <img
            src={
              thumbnail ||
              "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/dp%2F1680446972911%20-%20S2A.png?alt=media&token=16dd72c4-a7ad-47ae-8ba2-e06a3a12e528"
            }
            width={"100%"}
            height={200}
            alt="Thumbnail"
          />
        }
        width="100%"
        height={200}
        controls={true}
        // controls={isLocked ? false : true}
        config={{
          file: {
            attributes: {
              controlsList: "nodownload",
            },
          },

          vimeo: {
            playerOptions: { autoplay:false }
          },
        }}
        onStart={() => updateWatchTimes()}
      />
    </Fragment>
  );
};

export default VedioPlayer;
